import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { initAnalytics } from './lib/analytics'
import AuthShell from './AuthShell'
import AnalyticsProvider from './components/AnalyticsProvider'
import { AuthProvider } from './contexts/AuthContext'

initAnalytics()

ReactDOM.createRoot(document.getElementById('app') as HTMLElement).render(
  React.createElement(
    BrowserRouter,
    null,
    React.createElement(
      AuthProvider,
      null,
      React.createElement(AnalyticsProvider, null, React.createElement(AuthShell)),
    ),
  ),
)
